export const ON_INIT_CHANGE_ID = 'onInitChangeId';
export const UI_MODIFICATIONS_MODULE = 'jira:uiModifications' as const;
